import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UUID } from "angular2-uuid";
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from "ngx-loading";
import { AuthenticateService } from "../../shared/services/authenticate.service";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { CropsService } from "src/app/shared/services/crops.service";
import { ProfileService } from "src/app/shared/services/profile.service";
import { FileUploadService } from "src/app/shared/services/fileupload.service";

@Component({
  selector: "app-variety",
  templateUrl: "./variety.component.html",
  styleUrls: ["./variety.component.sass"],
})
export class VarietyComponent implements OnInit {
  @ViewChild("ngxLoading") ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild("customLoadingTemplate") customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public loading: boolean;
  showList: string = "crops";
  type: string = "save";
  index: number;
  cropDataArray = [];
  cobj: {
    maincropId: string;
    cropId: string;
    group: string;
    cropCategory: string;
    cropName: string;
    varietyName: string;
    varietyCode: string;
    duration: number;
    cropType: string;
    varietyImg: any;
    cropImages: any;
    cropTag: string;
  };
  imageNameList = [];
  cropForm: FormGroup;
  submitted = false;
  urls = [];
  cropNameList: any[];
  imageUploadService: string;
  mainUUID: any;
  globalImgUrl: string;
  groupName: string;
  uploadFileList = [];
  btnLoading: boolean = false;
  previousPage: number;
  skip: number;
  collectionSize: number;
  page = 1;
  searchStr: string = "";
  showsearchdata: boolean = true;
  categoryArray: any = [];
  mainVarietyUrl: string = "";
  mainImageUploadService: string;
  mainvarietyImage: any;
  mainVarietyId: string = "";
  languageList: any = [];
  regLanguage: string = "";
  name: string = "";
  langObj: any = {};
  langaugeArray: any = [];
  editLngRow: any[] = [];
  editLngObj: any = {};
  selectedCrop: any;
  componentData = undefined;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private fileUploadService: FileUploadService,
    private modalService: NgbModal,
    private profileService: ProfileService,
    private cognitoService: CognitoService,
    private cropsService: CropsService
  ) {}

  ngOnInit() {
    this.cognitoService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
      this.globalImgUrl = this.authService.s3url();
      this.getAllCategories();
    });
    this.languageList = [
      { languageName: "বাংলা", shortName: "BN" },
      { languageName: "ગુજરાતી", shortName: "GU" },
      { languageName: "हिन्दी", shortName: "HI" },
      { languageName: "ಕನ್ನಡ", shortName: "KN" },
      { languageName: "मराठी", shortName: "MR" },
      { languageName: "മലയാളം", shortName: "ML" },
      { languageName: "ଓଡ଼ିଆ", shortName: "OR" },
      { languageName: "ਪੰਜਾਬੀ", shortName: "PA" },
      { languageName: "தமிழ்", shortName: "TA" },
      { languageName: "తెలుగు", shortName: "TE" },
      { languageName: "اُردُو", shortName: "UR" },
    ];
    this.cropForm = this.formBuilder.group({
      cropCategory: ["", Validators.required],
      cropName: ["", Validators.required],
      varietyName: ["", Validators.required],
      varietyCode: ["", Validators.required],
      duration: ["", Validators.required],
      cropType: ["", Validators.required],
      cropTag: ["", Validators.required],
    });
  }

  getAllCategories() {
    this.categoryArray = [];
    let obj = {
      group: this.groupName,
    };
    this.cropsService.getCategories(obj).then((data: any) => {
      if (data.length > 0) {
        data.sort(function (a, b) {
          return a.categoryName.localeCompare(b.categoryName);
        });
        this.categoryArray = data;
      }
    });
  }
  handleNumber(event) {
    var ctl = document.getElementById("duration");
    var startPos = ctl["selectionStart"];
    if (startPos == 0 && event.which == 48) {
      return false;
    }
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  addData() {
    let language = this.languageList.filter(
      (item) => item.languageName == this.regLanguage
    )[0].shortName;
    let obj = {
      language: language,
      value: this.name,
    };
    this.langaugeArray.push(obj);
    this.regLanguage = "";
    this.name = "";
    console.log("langaugeArray", JSON.stringify(this.langaugeArray));
  }

  updateLngRow(updateIndex) {
    this.langaugeArray[updateIndex].language = this.languageList.filter(
      (item) => item.languageName == this.editLngObj.language
    )[0].shortName;
    this.langaugeArray[updateIndex].value = this.editLngObj.value;
    this.editLngRow = [];
    this.editLngObj = {};
    this.editLngRow[updateIndex] = false;
  }
  cancelLngRow(cancelIndex) {
    this.editLngRow = [];
    this.editLngObj = {};
    this.editLngRow[cancelIndex] = false;
  }
  deleteLngRow(index) {
    this.langaugeArray.splice(index, 1);
  }
  editLngRowData(editIndex) {
    this.editLngRow = [];
    this.editLngObj = {};
    this.editLngRow[editIndex] = true;
    this.editLngObj = this.langaugeArray[editIndex];
    this.editLngObj.language = this.languageList.filter(
      (item) => item.shortName == this.langaugeArray[editIndex].language
    )[0].languageName;
  }

  addLanguageData() {
    let obj = {};
    for (let i = 0; i < this.langaugeArray.length; i++) {
      obj[this.langaugeArray[i].language] = this.langaugeArray[i].value;
    }
    this.langObj = obj;
  }

  addForms() {
    this.btnLoading = false;
    this.cropForm.reset();
    this.showList = "addVariety";
    this.langaugeArray = [];
    this.cobj = {
      maincropId: "",
      cropTag: "",
      cropId: "",
      group: "",
      cropCategory: "",
      cropName: "",
      varietyName: "",
      varietyCode: "",
      duration: null,
      cropType: "",
      cropImages: [],
      varietyImg: "",
    };
    console.log("cobj ", this.cobj);
    this.type = "save";
  }

  back() {
    this.showList = "varieties";
    this.type = "save";
    this.cropForm.reset();
    this.imageNameList = [];
    this.langaugeArray = [];
    this.urls = [];
    this.getVarietiesByCrop(0, this.selectedCrop);
  }

  backToCrops() {
    this.showList = "crops";
  }

  onChangeVariety(variety) {
    console.log("variety", variety);
    let cropName = this.cropNameList.filter(
      (item) => item.maincropId == variety
    );
    console.log("cropName", cropName[0].cropName);
    this.cobj.cropName = cropName[0].cropName;
  }

  onChangeCategory(categoryid) {
    let catagory = this.categoryArray.filter(
      (item) => item.categoryId == categoryid
    );
    this.cobj.cropCategory = catagory[0].categoryName;
    let catagoryName = catagory[0].categoryName;
    this.cropNameList = [];
    let obj = {
      group: this.groupName,
      cropCategory: catagoryName,
    };
    this.cropsService.getCropByCategory(obj).then((data: any) => {
      data.sort(function (a, b) {
        return a.cropName.localeCompare(b.cropName);
      });
      for (var i = 0; i < data.length; i++) {
        this.cropNameList.push(data[i]);
      }
    });
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + "agri_logo.png";
  }

  closeModel() {
    this.regLanguage = "";
    this.name = "";
    this.langaugeArray = [];
  }

  openLanguageModel(content) {
    this.regLanguage = "";
    this.name = "";
    if (this.cobj["cropNameLang"] && this.langaugeArray.length == 0) {
      for (const [key, value] of Object.entries(this.cobj["cropNameLang"])) {
        let obj = {
          language: `${key}`,
          value: `${value}`,
        };
        this.langaugeArray.push(obj);
      }
      console.log("langaugeArray", this.langaugeArray);
    }
    let config: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg",
    };
    this.modalService.open(content, config);
  }

  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length;
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split("/")[0] == "image") {
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.urls.push(event.target.result);
          };
          reader.readAsDataURL(event.target.files[i]);
          let iuuid = UUID.UUID();
          this.imageUploadService =
            "var_" +
            iuuid +
            "." +
            event.target.files.item(0).type.split("/")[1];
          this.imageNameList.push(this.imageUploadService);
          const formData: FormData = new FormData();
          formData.set("file", event.target.files[i], this.imageUploadService);
          formData.append("name", this.imageUploadService);
          this.uploadFileList.push(formData);
        }
      }
    }
  }

  // Main Variety Image Upload Event
  mainImageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => {
        // called once readAsDataURL is completed
        this.mainVarietyUrl = event.target.result;
      };
      let iuuid = UUID.UUID();
      this.mainVarietyId = this.mainVarietyId ? this.mainVarietyId : iuuid;
      this.mainImageUploadService =
        this.mainVarietyId +
        "." +
        event.target.files.item(0).type.split("/")[1];
      this.mainvarietyImage = event.target.files[0];
    }
  }

  mainUploadFileToActivity() {
    if (this.mainvarietyImage != "") {
      this.fileUploadService.uploadFile(
        this.mainvarietyImage,
        this.mainImageUploadService
      );
    }
  }
  getVarietiesByCrop(skip, crop) {
    this.loading = true;
    this.selectedCrop = crop;
    this.showList = "varieties";
    this.showsearchdata = true;
    this.cropDataArray = [];
    var options = {
      group: this.groupName,
      maincropId: crop.maincropId,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip,
      // }
    };
    this.cropsService.getCropVarieties(options).then((data: any) => {
      if (data.length > 0) {
        this.cropDataArray = data;
        console.log("@@get crop varieties list:", data);
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = {
      group: this.groupName,
      maincropId: crop.maincropId,
    };
    this.cropsService.getCropVarietiesCount(count).then((data: any) => {
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    if (pageNumber !== this.previousPage) {
      this.skip = pageNumber * 20 - 20;
      this.previousPage = pageNumber;
      this.getVarietiesByCrop(this.skip, this.selectedCrop);
    }
  }

  uploadFileToActivity() {
    for (var i = 0; i < this.uploadFileList.length; i++) {
      this.fileUploadService.uploadMultipleFiles(
        this.uploadFileList[i],
        this.imageUploadService
      );
    }
  }

  deleteImage(index) {
    this.imageNameList.splice(index, 1);
    this.urls.splice(index, 1);
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.splice(index, 1);
    }
    console.log("deleteImage ", this.imageNameList);
  }

  saveData() {
    this.btnLoading = true;
    this.loading = true;
    this.uploadFileToActivity();
    // let uuid = UUID.UUID();
    // this.cobj.cropId = uuid;
    let uuid = this.mainVarietyId;
    this.cobj.cropId = uuid;
    // this.cobj.maincropId = this.mainUUID;
    // this.cobj.duration = parseInt(this.cobj.duration)
    console.log("cobj", this.cobj);
    this.cobj.cropImages = this.imageNameList;
    let temp = { EN: this.cobj.cropName };
    Object.assign(this.langObj, temp);
    this.cobj["varietyNameLang"] = this.langObj;
    this.cobj.varietyImg = this.mainImageUploadService;
    this.cobj.group = this.groupName;
    // this.cropDataArray.push(this.cobj);
    console.log("pushCropVariety obj", JSON.stringify(this.cobj));
    this.cropsService.pushCropVariety(this.cobj).then((data: any) => {
      console.log("pushCropVariety data", JSON.stringify(data));
      this.btnLoading = false;
      if (this.mainvarietyImage != undefined) {
        this.mainUploadFileToActivity();
      }
      if (data) {
        this.cropForm.reset();
        this.imageNameList = [];
        this.langaugeArray = [];
        this.urls = [];
        this.mainVarietyUrl = "";
        this.mainVarietyId = "";
        this.uploadFileList = [];
        this.showList = "varieties";
        // this.getAllVarieties();
        this.getVarietiesByCrop(0, this.selectedCrop);
      } else {
        this.btnLoading = false;
        this.loading = false;
        Swal.fire(
          "Error",
          "Data not Submitted (please contact admin)",
          "error"
        );
      }
    });
    console.log(this.cropDataArray);
  }

  editData(index) {
    console.log("@@EDit data:", this.cropDataArray[index]);
    this.cropNameList = [];
    this.langaugeArray = [];
    this.imageNameList = [];
    this.uploadFileList = [];
    this.mainVarietyUrl = "";
    this.urls = [];
    this.showList = "addVariety";
    this.index = index;
    this.cobj = this.cropDataArray[index];
    this.mainVarietyId = this.cropDataArray[index].cropId;
    this.cropNameList.push(this.cropDataArray[index]);
    this.type = "update";
    this.mainVarietyUrl = this.globalImgUrl + this.cobj.varietyImg;
    this.imageNameList = this.cropDataArray[index].cropImages;
    if (this.cropDataArray[index].varietyNameLang) {
      for (const [key, value] of Object.entries(
        this.cropDataArray[index].cropNameLang || []
      )) {
        let obj = {
          language: `${key}`,
          value: `${value}`,
        };
        if (obj["language"] != "EN") {
          this.langaugeArray.push(obj);
        }
      }
    }
    for (var i = 0; i < this.cropDataArray[index].cropImages.length; i++) {
      this.urls.push(
        this.globalImgUrl + this.cropDataArray[index].cropImages[i]
      );
      // this.uploadFileList.push(
      //   this.globalImgUrl + this.cropDataArray[index].cropImages[i]
      // );
    }
  }

  updateData() {
    this.loading = true;
    this.btnLoading = true;
    this.langObj = {};
    for (let i = 0; i < this.langaugeArray.length; i++) {
      this.langObj[this.langaugeArray[i].language] =
        this.langaugeArray[i].value;
    }
    let temp = { EN: this.cobj.cropName };
    let varietylang = Object.assign(this.langObj, temp);
    this.cobj["varietyNameLang"] = varietylang;
    this.cobj["varietyImg"] =
      this.mainImageUploadService != undefined
        ? this.mainImageUploadService
        : this.cobj.varietyImg;
    this.cobj.cropImages = this.cobj.cropImages.concat(
      this.imageNameList.filter((item) => {
        return this.cobj.cropImages.indexOf(item) < 0;
      })
    );
    let vobj = {
      varietyImg: this.cobj.varietyImg,
      varietyNameLang: this.cobj["varietyNameLang"],
      varietyName: this.cobj.varietyName,
      varietyImages: this.cobj.cropImages,
    };
    let profileObj = {
      group: this.groupName,
      cropId: this.cropDataArray[this.index].cropId,
      maincropId: this.cropDataArray[this.index].maincropId,
    };
    if (this.cobj["_id"]) delete this.cobj["_id"];
    this.cropsService.updateCropVariety(this.cobj).then((data: any) => {
      this.profileService
        .getProfileDefData(profileObj)
        .then((profileData: any) => {
          for (let i = 0; i < profileData.length; i++) {
            this.updateProfileDef(vobj, profileData[i]);
          }
        });
      if (this.uploadFileList.length > 0) {
        this.uploadFileToActivity();
      }
      this.btnLoading = false;
      if (this.mainvarietyImage != undefined) {
        this.mainUploadFileToActivity();
      }
      if (data) {
        Swal({ title: "Updated successfully" });
        this.cropForm.reset();
        this.imageNameList = [];
        this.langaugeArray = [];
        this.urls = [];
        this.uploadFileList = [];
        this.mainVarietyId = "";
        this.mainVarietyUrl = "";
        this.showList = "varieties";
        // this.getAllVarieties();
        this.getVarietiesByCrop(0, this.selectedCrop);
      } else {
        this.btnLoading = false;
        this.loading = false;
        Swal.fire(
          "Error",
          "Data not Submitted (please contact admin)",
          "error"
        );
      }
    });
  }

  updateProfileDef(pobj, selectedVariety) {
    this.profileService
      .updateVarietyProfileDef(pobj, selectedVariety)
      .then((data: any) => {
        console.log("upadate prof", data);
      });
  }

  searchByName() {
    if (this.searchStr != "") {
      this.loading = true;
      var obj = {
        group: this.groupName,
        field: "varietyName",
        text: this.searchStr,
        maincropId: this.selectedCrop.maincropId,
        tableName: "cropvarieties",
      };
      console.log("search obj : ", obj);
      this.cropsService.getcropvarietiesRegex(obj).then((data: any) => {
        console.log("searched", data);
        this.searchStr = "";
        this.cropDataArray = [];
        if (data.length > 0) {
          this.cropDataArray = data;
          this.showsearchdata = false;
          this.loading = false;
          console.log("cropDataArray", this.cropDataArray);
        } else {
          this.loading = false;
          this.showsearchdata = false;
        }
      });
    }
  }

  deleteData(index) {
    this.cropDataArray.splice(index, 1);
  }
}
